import React, {useEffect, useState} from 'react';
import RouterIcon from '../Assets/SVG/RouterIcon';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {RouterSelfInstallSteps} from '../Assets/variables';
import Stage4SVG from '../Assets/SVG/Stage4';

const IntroScreen = (props) => {
  return (
    <>
      <div className='svgContainerHead'>
        <Stage4SVG />
      </div>

      <RouterIcon />
      <div className='headBox'>
        <p className='heading'>רגע לפני הניוד</p>
        <p className='subHeading'>במסך הבא נגדיר את שם הרשת והסיסמה</p>
      </div>
      <div className='fixFooter'>
        <BtnSubmit
          className='mb-12'
          text={'בואו נמשיך'}
          onclick={() => {
            props.setStep(RouterSelfInstallSteps.NETCONFIG);
          }}
        />
      </div>
    </>
  );
};

export default IntroScreen;
